<template>
    <a-modal v-model="visible" title="店主信息" >
        <p v-for="info in infos">{{info}}</p>
        <template slot="footer">
            <a-button key="submit" type="primary" @click="handleOk">
                确定
            </a-button>
        </template>
    </a-modal>
</template>
<script>
    import userService from '@/service/user'
    export default {
        data() {
            return {
                visible: false,
                infos: []
            };
        },
        methods: {
            showModal(ownerId) {
                this.visible = true;
                this.infos = []
                userService.getOwnerInfo( {ownerId}).then((res) => {
                    if(res.success) {
                        this.infos.push("昵称：" + res.data.nickname)
                        this.infos.push("手机号：" + res.data.phone)
                    } else {
                        this.infos.push('获取失败')
                    }
                }).catch(()=>{
                    this.infos.push('获取失败')
                })
            },
            handleOk(e) {
                this.visible = false;
            },
        },
    };
</script>
